import { render, staticRenderFns } from "./OrmBatchingQuotes.vue?vue&type=template&id=510b1442"
import script from "./OrmBatchingQuotes.vue?vue&type=script&lang=js"
export * from "./OrmBatchingQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510b1442')) {
      api.createRecord('510b1442', component.options)
    } else {
      api.reload('510b1442', component.options)
    }
    module.hot.accept("./OrmBatchingQuotes.vue?vue&type=template&id=510b1442", function () {
      api.rerender('510b1442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/OrmBatchingQuotes.vue"
export default component.exports